/*
 * Feature Flag
 */
export const FEATURE_FLAG_QUERY_KEY = ['FeatureFlag']

/*
 * Experiment
 */
export const EXPERIMENT = ['Experiment']

/*
 * Accredited Establishments
 */
export const ACCREDITED_ESTABLISHMENTS_PLANS_FILTER = [
  'AccreditedEstablishments',
  'PlansFilter'
]
export const ACCREDITED_ESTABLISHMENTS_ADDRESS_FILTER = [
  'AccreditedEstablishments',
  'AddressFilter'
]
export const ACCREDITED_ESTABLISHMENTS_SPECIALTIES_FILTER = [
  'AccreditedEstablishments',
  'SpecialtiesFilter'
]
export const ACCREDITED_ESTABLISHMENTS_SUB_SPECIALTIES_FILTER = [
  'AccreditedEstablishments',
  'SubSpecialtiesFilter'
]
export const ACCREDITED_ESTABLISHMENTS_SEARCH = [
  'AccreditedEstablishments',
  'Search'
]
export const ACCREDITED_ESTABLISHMENTS_LIST = [
  'AccreditedEstablishments',
  'List'
]
export const ACCREDITED_ESTABLISHMENT_MARKERS = [
  'AccreditedEstablishments',
  'Markers'
]
export const ACCREDITED_ESTABLISHMENTS_SPECIALIST = [
  'AcreditedEstablishments',
  'Specialists'
]
export const ACCREDITED_ESTABLISHMENTS_PROVIDER = [
  'AcreditedEstablishments',
  'Providers'
]
export const ACCREDITED_ESTABLISHMENTS_HOSPITAL = [
  'AcreditedEstablishments',
  'Hospital'
]
export const ACCREDITED_ESTABLISHMENTS_LABORATORY = [
  'AcreditedEstablishments',
  'Laboratory'
]

/*
 * Data confirmation
 */
export const CONTACT_UPDATE = ['ContactUpdate']
